export default "__VITE_ASSET__BYt0ZkNB__"